import {subscriptionActionTypes} from "../_constants/actions/subscriptionActionTypes";

export function subscriptions(state = {}, action) {
  switch (action.type) {

    // subscribe success
    case subscriptionActionTypes.SUBSCRIBE_SUCCESS:
      return {
        ...state,
        subscribe: {
          isLoading: false,
          isSuccess: true,
          isFailure: false,
        }
      };

    // subscribe request
    case subscriptionActionTypes.SUBSCRIBE_REQUEST:
      return {
        ...state,
        subscribe: {
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        }
      }

    // subscribe failure
    case subscriptionActionTypes.SUBSCRIBE_FAILURE:
      return {
        ...state,
        subscribe: {
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        }
      }

    // get subscription success
    case subscriptionActionTypes.GET_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        current: {
          isSuccess: true,
          isLoading: false,
          isFailure: false,
          subscriptions: action.subscriptions
        }
      }
      
    // get subscription request
    case subscriptionActionTypes.GET_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        current: {
          isSuccess: false,
          isLoading: true,
          isFailure: false,
          subscriptions: []
        }
      }
      
    // get subscription failure
    case subscriptionActionTypes.GET_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        current: {
          isSuccess: false,
          isLoading: false,
          isFailure: true,
          subscriptions: []
        }
      }

    default:
      return state
  }
}